module.exports = __webpack_public_path__ + "img/ry／pic.68065f59.png";